export enum ActionTypes {
    SET_COUNTRY = 'SET_COUNTRY',
    SET_SUPPORTED_COUNTRIES = 'SET_SUPPORTED_COUNTRIES'
}
